export default class Report {
    public type = {
        terse: true,
        complete: false,
    };
}